import { Component, OnInit, ViewChild } from "@angular/core";
import { BpgCommonService } from "../bpg-common/services/bpg-common.service";
import { Router } from "@angular/router";
import { BpgChapterHomePageService } from "./bpg-chapter-home-page.service";
import { BpgEventsService } from "../bpg-events/bpg-events.service";
import { DatePipe } from "@angular/common";
import { ConstantValues } from "../bpg-common/models/bpg-constants";
import { DataService } from "..//bpg-common/services/data.services";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { EnvironmentConfiguration } from "../environment/services/environment.configuration";
import { NgbCarouselConfig, NgbCarousel } from "@ng-bootstrap/ng-bootstrap";
import { SelfService } from "../bpg-self-services/self-services.service.ts";

@Component({
  selector: "app-bpg-chapter-home-page",
  templateUrl: "./bpg-chapter-home-page.component.html",
  styleUrls: ["./bpg-chapter-home-page.component.css"],
  providers: [NgbCarouselConfig],
})
export class BpgChapterHomePageComponent implements OnInit {
  vision: string;
  leaderInfo: any;
  heplinghandUrl = "assets/images/image_07.jpg";
  withdrawMembershipPara =
    "Do you want to withdraw your membership, click here.";
  eventDetails1: string;
  eventFullDetails: string;
  eventId: any;
  upcomingEventsInfo: any;
  chapterDetailsData: any;
  chapterDetails: any = { chapterBanner: "" };
  chapterLeadershipDetails: any;
  chapterExecutiveSponsorDetails: any;
  loginData: any;
  successMsgShow: boolean;
  chapterId: any;
  chaptersArrayList: Array<any>;
  url = "";
  skipRoute = false;
  onFirstRender = false;
  adminId: any = localStorage.getItem("adminId");
  siteIdForCalender: any = localStorage.getItem("selectedSiteId");
  bpgIdForCalender: any = localStorage.getItem("bpgId");
  siteIdFromLocal = localStorage.getItem("siteId");
  siteId: any;
  bpgId: any;
  eventName: any;
  contactusflag: any;
  landingData: any;
  eventDetails = [];
  awsChapterBannerUrl: string;
  awsChapterLeadershipPhotoUrl: string;
  myBpgsData: any;
  loginDetails: any = JSON.parse(localStorage.getItem("loginData"));
  timeOutError: boolean;
  timeoutErrorMessage: string = ConstantValues.timeoutErrorMessage;
  galleryItemsList: any = null;
  chapterFolderList: any = [];
  fileList: any = [];
  chapterResourceList: any = [];
  noFolderFound = false;
  announcementList: any = [];
  noAnnouncementFound: boolean;
  chapterFeedback: any = "";
  sendFeedback: boolean;
  errorMsg: any;
  sendFeedbackFailure = false;
  chapterFeedbackList: any = [];
  addChapterFeedback = false;
  chapterBoardList: any = [];
  @ViewChild("carousel", { static: false }) carousel: NgbCarousel;
  naacFolderList: any = [];
  naacResourceList: any = [];
  sendData: any;
  flag2 = true;
  /**
   * @class BpgChapterHomePageComponent
   * @constructor
   */
  constructor(
    private readonly userService: SelfService,
    private readonly bpgCommonService: BpgCommonService,
    private readonly router: Router,
    private readonly bpgChapterService: BpgChapterHomePageService,
    private readonly bpgEventsService: BpgEventsService,
    private readonly datePipe: DatePipe,
    private readonly data: DataService,
    private readonly spinnerService: Ng4LoadingSpinnerService,

    private readonly environment: EnvironmentConfiguration,
    private readonly config: NgbCarouselConfig
  ) {
    config.interval = 5000;
    config.wrap = true;
    config.keyboard = true;
    config.pauseOnHover = true;
    config.showNavigationIndicators = false;
  }

  ngOnInit() {
    this.spinnerService.show();
    if (
      this.environment.envName === "dev" ||
      this.environment.envName === "qa" ||
      this.environment.envName === "prod"
    ) {
      if (
        localStorage.getItem("loginData") == null ||
        localStorage.getItem("loginData") === undefined
      ) {
        this.router.navigate(["/log-out"]);
      }
    }
    localStorage.removeItem("searchedEventsCaledarItems");

    this.awsChapterBannerUrl = localStorage.getItem("chapterBannerBaseUrl");
    this.awsChapterLeadershipPhotoUrl = localStorage.getItem(
      "chapterLeadershipBannerBaseUrl"
    );
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
    window.onload = function () {
      setTimeout(function () {
        scrollTo(0, 0);
      });
    };

    this.data.myBpgsData.subscribe((myBpgsData) => {
      this.myBpgsData = myBpgsData;
      if (this.myBpgsData.path === "myBpg") {
        this.chapterDetailsData = {
          bpgId: this.myBpgsData.bpgId
            ? this.myBpgsData.bpgId
            : this.bpgIdForCalender,
          siteId: this.myBpgsData.siteId
            ? this.myBpgsData.siteId
            : localStorage.getItem("userSiteId"),
          // localStorage.getItem('userSiteId') -> should check 27/10/2020
        };
      } else {
        this.chapterDetailsData = {
          bpgId: this.myBpgsData.bpgId
            ? this.myBpgsData.bpgId
            : this.bpgIdForCalender,
          siteId: this.myBpgsData.siteId
            ? this.myBpgsData.siteId
            : this.siteIdFromLocal,
        };
      }

      this.getChapterDetails();

      this.getChapterFolderDetails();
      this.getChapterFileDetails();
      this.getChapterAnnouncements();
      this.getChapterBoard();
      const fromDate = this.datePipe.transform(
        new Date(),
        ConstantValues.dateFormats.dateFormat
      );
      const toDate = this.datePipe.transform(
        this.addDays(new Date(), 365),
        ConstantValues.dateFormats.dateFormat
      );

      this.landingData = {
        filter: {
          siteId: this.chapterDetailsData.siteId,
          bpgId: this.chapterDetailsData.bpgId,
          fromDate: fromDate,
          toDate: toDate,
          chapterEmail: this.chapterDetailsData.chapterEmail,
        },

        moduleId: 0,
        page: 0,
        presentRole: "",
        searchTerm: "",
        size: 3,
        sortDirection: "ASC",
        sortProperty: "event_create_date",
        uid: "",
      };
      this.bpgEventsService.getAllEvents(this.landingData).subscribe((data) => {
        if(data.content!=null){
          this.upcomingEventsInfo = data.content ? data.content : "";
          if (this.upcomingEventsInfo.length > 0) {
            this.eventDetails1 = this.upcomingEventsInfo[0].description;
            this.eventName = this.upcomingEventsInfo[0].eventName;
            this.eventId = this.upcomingEventsInfo[0].eventId;
          } else {
            this.eventDetails1 = "";
            this.eventName = "No upcoming events available";
            this.eventId = "";
          }
        }
      });
    });

    setTimeout(
      function () {
        this.spinnerService.hide();
      }.bind(this),
      1000
    );
  }

  /** get gallery list
   * @class ConfigureGalleryComponent
   * @method getChapterGalleryList
   */
  getChapterGalleryList(chapterId) {
    this.landingData = {
      filter: { chapterId: chapterId, siteId: 0, bpgId: 0, title: "home" },
      moduleId: 0,
      page: 0,
      presentRole: "string",
      searchTerm: "string",
      size: 100,
      sortDirection: "DESC",
      sortProperty: "created_date_time",
      uid: "string",
    };

    this.userService
      .getChapterGalleryList(this.landingData)
      .subscribe((data) => {
        this.galleryItemsList =
          data !== null && data !== undefined ? data.content : null;
      });
  }

  /** For getting  chapter related folder details
   * @class BpgChapterHomePageComponent
   * @method getChapterDetails
   */
  getChapterFolderDetails() {
    const landingData = {
      filter: {
        siteId: this.chapterDetailsData.siteId,
        bpgId: this.chapterDetailsData.bpgId,
      },
      moduleId: 0,
      presentRole: "",
      searchTerm: "",
      size: 100,
      sortDirection: "ASC",
      sortProperty: "",
      uid: "",
    };
    this.bpgCommonService
      .getChapterFolderDetails(landingData)
      .subscribe((data) => {
        this.chapterFolderList = data;
        if (
          this.chapterFolderList !== null &&
          this.chapterFolderList !== undefined
        ) {
          for (const chapterFolder of  this.chapterFolderList) {
            chapterFolder.Maxmin = "+";
          }
        }
        if (this.chapterFolderList.length === 0) {
          this.noFolderFound = true;
        }
      });
  }

  public getnaacFolderList() {
    const landingData = {
      filter: {
        bpgId: this.chapterDetailsData.bpgId,
      },
      moduleId: 0,
      page: 0,
      presentRole: "",
      searchTerm: "",
      size: 50,
      sortDirection: "ASC",
      sortProperty: "folder_order",
      uid: "",
    };
    this.userService.getNaacDocumentsFolder(landingData).subscribe((data) => {
      this.naacFolderList = data.content;
      if (this.naacFolderList != null) {
        for (const naacFolder of  this.naacFolderList) {
          this.chapterFolderList.push(naacFolder);
        }
      }
      if (
        this.chapterFolderList !== null &&
        this.chapterFolderList !== undefined
      ) {
        for (const chapterFolder of this.chapterFolderList) {
        chapterFolder.Maxmin = "+";
        }
      }
      if (this.chapterFolderList.length === 0) {
        this.noFolderFound = true;
      }
    });
  }

  /** to get chapter member list
   * @class chapterBoardComponent
   * @method getChapterBoard
   */

  getChapterBoard() {
    const LandingPaginationDTO = {
      filter: {
        siteId: this.chapterDetailsData.siteId,
        bpgId: this.chapterDetailsData.bpgId,
        chapterFlag: "chapterHomePage",
      },
      moduleId: 0,
      page: 0,
      presentRole: "",
      searchTerm: "",
      size: 500,
      sortDirection: "ASC",
      sortProperty: "teamOrder",
      uid: "",
    };

    this.userService
      .getChapterBoardMember(LandingPaginationDTO)
      .subscribe((data) => {
        if (data != null && data.content != null && data.content !== undefined) {
          this.chapterBoardList = data.content;
        }
      });
    this.spinnerService.hide();
  }

  /** get files list
   * @class ConfigureGalleryComponent
   * @method getChapterFileDetails
   */
  getChapterFileDetails() {
    this.landingData = {
      filter: {
        siteId: this.chapterDetailsData.siteId,
        bpgId: this.chapterDetailsData.bpgId,
        type: "document",
      },
      moduleId: 0,
      page: "",
      presentRole: "string",
      searchTerm: "string",
      size: 500,
      sortDirection: "DESC",
      sortProperty: "created_date_time",
      uid: "string",
    };

    this.userService
      .getChapterGalleryList(this.landingData)
      .subscribe((data) => {
        this.chapterResourceList = data.content;
        if (this.chapterResourceList) {
          for (const chapterResource of this.chapterResourceList) {
            chapterResource.docType = "chapter";
          }
        }
      });
  }

  getNaacResouceList() {
   
    this.landingData = {
      filter: {
        naacFlag: "naacHomePage",
        bpgId: this.chapterDetailsData.bpgId,
      },
      moduleId: 0,
      page: 0,
      presentRole: "",
      searchTerm: "",
      size: 500,
      sortDirection: "ASC",
      sortProperty: "folder_order",
      uid: "",
    };
    this.userService.getnaacResource(this.landingData).subscribe((data) => {
      this.naacResourceList = data.content;
      if (this.naacResourceList != null && this.naacResourceList.length > 0) {
        for (const naacResource of this.naacResourceList.length) {
          this.chapterResourceList.push({
            folderId: naacResource.folderId,
            folderName: naacResource.folderName,
            documentName: naacResource.naacResourceTitle,
            fileName: naacResource.naacResourceDocument,
            originalFileName: naacResource.originalFileName,
            docType: "naac",
            naacId: naacResource.naacId,
            naacResourceId: naacResource.naacResourceId,
            downloadsCount: naacResource.downloadsCount,
          });
        }
      }
    });
  }
  /** get Chapter Feedback
   * @class ConfigureGalleryComponent
   * @method getChapterFeedback
   */
  getChapterFeedback() {
    const getFeedbackData = {
      filter: {
        siteId: this.chapterDetailsData.siteId,
        bpgId: this.chapterDetailsData.bpgId,
      },
      moduleId: 0,
      page: 0,
      presentRoles: "",
      searchTerm: "",
      size: 500,
      sortDirection: "DESC",
      sortProperty: "feedback_id",
      uid: this.loginDetails.userId,
    };

    this.userService.getChapterFeedback(getFeedbackData).subscribe((data) => {
      if (data.content != null && data.content !== undefined) {
        this.chapterFeedbackList = data.content;
      }
  
    });
  }
  cancelChapterFeedback() {
    this.addChapterFeedback = false;
  }
  addchapterFeedback() {
    this.addChapterFeedback = true;
  }
  /** send Chapter Feedback
   * @class ConfigureGalleryComponent
   * @method sendChapterFeedback
   */
  sendChapterFeedback() {
    const feedbackData = {
      userId: this.loginDetails.userId,
      userEmail: this.loginDetails.emailId,
      workdayId: this.loginDetails.workdayId,
      chapterFeedback: this.chapterFeedback,
      siteId: this.chapterDetailsData.siteId,
      bpgId: this.chapterDetailsData.bpgId,
      feedbackId: 0,
    };

    this.userService.sendChapterFeedback(feedbackData).subscribe((data) => {
      if (data.message) {
        this.errorMsg = data.message;
        this.sendFeedbackFailure = true;
      } else if (data.body !== null && data.body !== undefined) {
        this.sendFeedbackFailure = false;
        this.sendFeedback = true;

        this.sendFeedback = false;
        this.chapterFeedback = "";
        this.addChapterFeedback = false;
      }
    });
  }

  /** get files list
   * @class ConfigureGalleryComponent
   * @method getChapterAnnouncements
   */
  getChapterAnnouncements() {
    this.landingData = {
      filter: {
        siteId: this.chapterDetailsData.siteId,
        bpgId: this.chapterDetailsData.bpgId,
      },
      moduleId: 0,
      page: "",
      presentRole: "string",
      searchTerm: "string",
      size: 50,
      sortDirection: "DESC",
      sortProperty: "createdDateTime",
      uid: "string",
    };

    this.userService
      .getChapterAnnouncementList(this.landingData)
      .subscribe((data) => {
        if (data != null && data.content != null && data.content !== undefined) {
        this.announcementList = data.content;

        if (this.announcementList.length === 0) {
          this.noAnnouncementFound = true;
        } else {
          this.noAnnouncementFound = false;
          for (const announcement of  this.announcementList) {
            if (
              announcement.announcementFile === null ||
              announcement.announcementFile === undefined ||
              announcement.announcementFile === ""
            ) {
              announcement.presignedUrl =
                "/assets/images/news_logo.jpg";
            }
            if (
              announcement.announcementFile
                .toLowerCase()
                .indexOf(".pdf") !== -1
            ) {
              announcement.fileDownloadURL =
              announcement.presignedUrl;
              announcement.presignedUrl = "/assets/images/pdf1.png";
            } else if (
              announcement.announcementFile
                .toLowerCase()
                .indexOf(".doc") !== -1 ||
                announcement.announcementFile
                .toLowerCase()
                .indexOf(".txt") !== -1
            ) {
              announcement.fileDownloadURL =
              announcement.presignedUrl;
              announcement.presignedUrl = "/assets/images/txt1.png";
            } else if (
              announcement.announcementFile
                .toLowerCase()
                .indexOf(".ppt") !== -1 ||
                announcement.announcementFile
                .toLowerCase()
                .indexOf(".pptx") !== -1
            ) {
              announcement.fileDownloadURL =
              announcement.presignedUrl;
              announcement.presignedUrl = "/assets/images/ppt1.png";
            } else if (
              announcement.announcementFile
                .toLowerCase()
                .indexOf(".xlsx") !== -1 ||
                announcement.announcementFile
                .toLowerCase()
                .indexOf(".csv") !== -1
            ) {
              announcement.fileDownloadURL =
              announcement.presignedUrl;
              announcement.presignedUrl =
                "/assets/images/excel-doc.png";
            }
          }

          for (const announcement of this.announcementList) {
            if (
              announcement.announcementDescription !== null &&
              announcement.announcementDescription !== "" &&
              announcement.announcementDescription !== undefined
            ) {
              announcement.wordCount =
              announcement.announcementDescription.split(
                  " "
                ).length;
              if (announcement.wordCount >= 30) {
                announcement.minWord = announcement.announcementDescription.slice(0, 160);
                announcement.minWord =
                announcement.minWord + "...";
                announcement.showFullWord = false;
              } else {announcement.showFullWord = true;
              }
            } else {
              announcement.showFullWord = true;
            }
          }
          const element = document.getElementById("newsId");
          if (this.announcementList.length === 2) {
            element.className = "news-scroll";
            element.style["animationDuration"] =
              `${this.announcementList.length * 6}s`;
          } else if (this.announcementList.length > 2) {
            element.className = "news-scroll";
            element.style["animationDuration"] =
            `${this.announcementList.length * 3.5}s`;
          } else {
            element.className = "none";
          }
        }
      }
      });
  }

  /** For displaying full description
   * @class showFullDescComponent
   * @method showFullDesc
   */
  showFullDesc(id) {
    for (const announcement of  this.announcementList.length) {
      if (announcement.chaptersAnnouncementId === id) {
        announcement.showFullWord = true;
      }
    }
  }
  /** For displaying files based on folder selection
   * @class EventViewDetailsComponent
   * @method selectdiFolder
   */
  selectdiFolder(folderid, folderName) {
    this.fileList = [];

    for (const chapterResource of this.chapterResourceList) {
      if (
        chapterResource.folderId === folderid &&
        chapterResource.folderName === folderName
      ) {
        this.fileList.push(chapterResource);
      }
    }
    for (const chapterFolderList of this.chapterFolderList) {
      if (chapterFolderList.folderId === folderid) {
        if (
          chapterFolderList.showFolder === false ||
          chapterFolderList.showFolder === undefined ||
          chapterFolderList.showFolder === null
        ) {
          chapterFolderList.Maxmin = "-";
          chapterFolderList.showFolder = true;
        } else {
          chapterFolderList.Maxmin = "+";
          chapterFolderList.showFolder = false;
        }
      } else {
        chapterFolderList.Maxmin = "+";
        chapterFolderList.showFolder = false;
      }
    }
  }

  /** For getting all chapter related details
   * @class BpgChapterHomePageComponent
   * @method getChapterDetails
   */
  getChapterDetails() {
    this.timeOutError = false;
    this.bpgCommonService
      .getChapterDetails(this.chapterDetailsData)
      .subscribe((data) => {
        this.chapterDetails = data;
        this.getChapterGalleryList(this.chapterDetails.chapterId);
        this.getChapterLeadershipDetails();
      });
  }

  /** For getting the leadership details of particluar chapter
   * @class BpgChapterHomePageComponent
   * @method getChapterLeadershipDetails
   */
  leadersUrl: any;
  getChapterLeadershipDetails() {
    this.timeOutError = false;
    this.chapterId = { chapterId: this.chapterDetails.chapterId };
    this.bpgCommonService.getChapterLeadershipDetails(this.chapterId).subscribe(
      (data) => {
        if (data != null || data !== undefined) {
          this.chapterLeadershipDetails = data.chaptersLeadershipResponseDTOs;
          this.chapterExecutiveSponsorDetails =
            data.chaptersExecutiveSponsorDTO;
        }

      },
      (err) => {
        console.log(JSON.stringify(err.value.message));
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
  }

  /** For displaying the events name and description when clicked on event title or date
   * @class BpgChapterHomePageComponent
   * @method openeventsDetails
   * @param eventId
   */
  openeventsDetails(eventId) {
    document
      .getElementById("event_description_div")
      .scrollIntoView({ behavior: "smooth", block: "center" });
    for (let i = 0; i < this.upcomingEventsInfo.length; i++) {
      if (eventId === this.upcomingEventsInfo[i].eventId) {
        this.eventId = eventId;
        document
          .getElementById(`eventlist${i}${i}`)
          .classList.add("hideArrow");
        this.eventName = this.upcomingEventsInfo[i].eventName;
        this.eventDetails1 = this.upcomingEventsInfo[i].description;
      }
      if (eventId !== this.upcomingEventsInfo[i].eventId) {
        if (i === 0) {
          document
            .getElementById(`eventlist${i}${i}`)
            .classList.add("hideDiv");
        }
        document
          .getElementById(`eventlist${i}${i}`)
          .classList.remove("hideArrow");
      }
  
    }
  }

  /** For redirecting to events calendar list view
   * @class BpgChapterHomePageComponent
   * @method viewMoreEvents
   */
  viewMoreEvents() {
    window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
    const navigatePath = "chapterHome";
    const idsAndNavigatePath = {
      siteId: this.siteIdForCalender,
      bpgId: this.bpgIdForCalender,
      bpgName: this.chapterDetails.bpgName,
      path: navigatePath,
    };
    this.data.selectedSiteIdAndPath(idsAndNavigatePath);
    this.router.navigate(["events-list-view"]);
  }

  /** For displaying complete description when 'view details' is clicked
   * @class BpgChapterHomePageComponent
   * @method viewMoreEventsDetails
   * @param eventId
   */
  viewMoreEventsDetails(eventId) {
    for (const upcomingEvent of this.upcomingEventsInfo) {
      if (upcomingEvent.eventId === eventId) {
        this.eventDetails = upcomingEvent;
        Object.assign(this.eventDetails, {
          componentName: "bpgChapterHomePage",
        });
        this.data.getSelectedEventDetails(this.eventDetails);
        sessionStorage.setItem(
          "eventDetails",
          JSON.stringify(this.eventDetails)
        );
        this.router.navigate(["event-view-details"]);
      }
    }
  }
  contactUs() {
    this.contactusflag = this.chapterDetails.chapterEmail;
    window.location.assign("mailto:" + this.contactusflag);
  }
  /** For withdrawing membership from bpg
   * @class BpgChapterHomePageComponent
   * @method withdrawMembership
   */
  withdrawMembership() {
    this.timeOutError = false;
    this.loginData = JSON.parse(localStorage.getItem("loginData"));
    this.bpgCommonService.withdrawMemberShip(this.loginData.userId).subscribe(
      (_data) => {
        this.successMsgShow = true;
        window.scrollTo(0, 0);
        setTimeout(
          function () {
            this.successMsgShow = false;
          }.bind(this),
          3000
        );
      },
      (err) => {
        console.log(JSON.stringify(err.value.message));
        if (err.value.statusText === ConstantValues.unknownError) {
          this.timeOutError = true;
        }
      }
    );
    window.location.reload();
  }

  /** For redirecting to chapter self service page
   * @class BpgChapterHomePageComponent
   * @method configureCHAPTER
   */
  configureCHAPTER() {
    this.chaptersArrayList = [];
    this.chaptersArrayList.push(this.chapterDetails);
    this.chaptersArrayList.push(this.chapterLeadershipDetails);
    this.bpgChapterService.bpgChapterDetails(this.chaptersArrayList);
    this.router.navigate(["/chapter-services"]);
  }
  /** For adding 365 days to current day
   * @class BpgSiteHomePageComponent
   * @method addDays
   * @params Date, number
   */
  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  /** For download files of the events
   * @class EventViewDetailsComponent
   * @method downloadAttachments
   */
  downloadAttachments(file, i, downloadType) {
    const urls = file.fileName;
    const fName = file.originalFileName;
    const extension = fName.substring(fName.lastIndexOf(".") + 1);
    const link = document.getElementById(downloadType + i);

    link.setAttribute("href", urls);
    link.setAttribute("download", urls);
    if (extension.includes('mp4')) {
      link.setAttribute('target', '_blank');
    }
    if (extension === 'pdf' || 'csv') {
      link.setAttribute('target', '_blank');
    }
    if (extension === "mp3" && downloadType === "resFile") {
       this.trackViews(file)
    }
  }
 
  trackViews(file)
  {
    if (file.docType === "chapter") {
      this.sendData = {
        filter: {
          flag: file.docType,
          naacResourceId: "",
          galleryId: file.galleryId,
          chapterId: file.chapterId,
        },
        moduleId: 0,
        page: 0,
        presentRole: "",
        searchTerm: "",
        size: 10,
        sortDirection: "ASC",
        sortProperty: "",
        uid: "",
      };
    }
    if (file.docType === "naac") {
      this.sendData = {
        filter: {
          flag: file.docType,
          naacResourceId: file.naacResourceId,
          galleryId: "",
          folderId: "",
          originalFileName: "",
        },
        moduleId: 0,
        page: 0,
        presentRole: "",
        searchTerm: "",
        size: 10,
        sortDirection: "ASC",
        sortProperty: "",
        uid: "",
      };
    }
    this.userService.trackPostCastViews(this.sendData).subscribe((data) => {
      if (
        data.message === "updated successfully" &&
        file.docType === "chapter"
      ) {
        for (const val of this.fileList) {
          if (val.galleryId === data.galleryId) {
            val.downloadsCount = data.count;
            break;
          }
        }
      }
      if (data.message === "updated successfully" && file.docType === "naac") {
        for (const file of this.fileList) {
          if (file.naacResourceId === data.naacResourceId) {
            file.downloadsCount = data.count;
            break;
          }
        }
      }
    });
  }
  /** For download files of the announcements
   * @class EventViewDetailsComponent
   * @method downloadAttachments
   */
  downloadFile(urls) {
    const extension = urls.substring(urls.lastIndexOf(".") + 1);
    const link = document.getElementById("downloadFile");
    link.setAttribute("href", urls);
    link.setAttribute("download", urls);
    if (extension.includes("mp4")) {
      link.setAttribute("target", "_blank");
    }

  }
  onSlide(_event) {
    const videoList = document.getElementsByTagName("video");
    for (let i = 0; i <= videoList.length; i++) {
      if (videoList[i] !== undefined) {
        videoList[i].pause();
      }
    }
  }
}

export class chapterArray {
  chapterDetails: any;
  capterLeadershipDetails: any;
}
